module.exports = __webpack_public_path__ + "static/media/FuturaStd-Bold.54f3c433.svg";